/**
 * Bootstrap 5 only listens for data-bs-* on the document.
 * Legacy views still use BS3/4 names (data-toggle, data-target, data-dismiss, …).
 * Migrate known component toggles in-place so Modals, Dropdowns, Collapse, Tabs, etc. work.
 *
 * Skips non-Bootstrap values (e.g. data-toggle="position", "bs-switchery") so custom code keeps working.
 */

const LEGACY_TOGGLE_VALUES = new Set([
  "modal",
  "dropdown",
  "collapse",
  "tab",
  "pill",
  "list",
  "tooltip",
  "popover",
  "button",
  "buttons",
]);

function renameAttr(el, from, to) {
  if (!el.hasAttribute(from) || el.hasAttribute(to)) return;
  el.setAttribute(to, el.getAttribute(from));
  el.removeAttribute(from);
}

function migrateRoot(root) {
  const searchRoot = root && root.querySelector ? root : document;

  searchRoot.querySelectorAll("[data-toggle]").forEach((el) => {
    const val = el.getAttribute("data-toggle");
    if (!val || !LEGACY_TOGGLE_VALUES.has(val)) return;

    el.setAttribute("data-bs-toggle", val);
    el.removeAttribute("data-toggle");

    if (el.hasAttribute("data-target") && !el.hasAttribute("data-bs-target")) {
      el.setAttribute("data-bs-target", el.getAttribute("data-target"));
      el.removeAttribute("data-target");
    }
  });

  searchRoot.querySelectorAll("[data-dismiss]").forEach((el) => {
    renameAttr(el, "data-dismiss", "data-bs-dismiss");
  });

  searchRoot.querySelectorAll('[data-bs-toggle="collapse"][data-parent]').forEach((el) => {
    renameAttr(el, "data-parent", "data-bs-parent");
  });

  searchRoot.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    renameAttr(el, "data-placement", "data-bs-placement");
  });

  searchRoot.querySelectorAll('[data-bs-toggle="popover"]').forEach((el) => {
    renameAttr(el, "data-placement", "data-bs-placement");
    renameAttr(el, "data-content", "data-bs-content");
    renameAttr(el, "data-html", "data-bs-html");
    renameAttr(el, "data-trigger", "data-bs-trigger");
    renameAttr(el, "data-container", "data-bs-container");
  });
}

export default function migrateBootstrapDataAttributes(root = document) {
  try {
    migrateRoot(root);
  } catch (e) {
    if (typeof gon !== "undefined" && gon.env === "development") {
      // eslint-disable-next-line no-console
      console.error("[migrateBootstrapDataAttributes]", e);
    }
  }
}
